export default __webpack_public_path__ + "media/4c46f2a42b8b5a3593808b1871c73cc69eefe7afec3a60b92db6c79db791de27.svg";